module.exports = __webpack_public_path__ + "img/hulianwang.e8b351e7.png";